import * as Yup from 'yup'
import { isValidPhoneNumber } from 'libphonenumber-js/mobile'
import { i18n } from 'i18next'

// eslint-disable-next-line import/no-cycle
import i18nInstance from '../i18n'

// TYPESCRIPT

declare module 'yup' {
  export interface StringSchema {
    /**
     * Check for phone number validity.
     * @param errorMessage - The error message to return if validation fails
     */
    phone(errorMessage?: string): StringSchema
  }
}

// CUSTOM METHODS

Yup.addMethod(Yup.string, 'phone', function (errorMessage?: string) {
  const errMsg =
    typeof errorMessage === 'string' && errorMessage
      ? errorMessage
      : i18nInstance.t('form.error.phone')

  return this.test('phone', errMsg, (value?: string) => {
    if (value === undefined || value === '') {
      return true
    }
    return isValidPhoneNumber(value)
  })
})

// CUSTOM LOCALES

export const setYupLocale = (_i18nInstance: i18n) => {
  Yup.setLocale({
    mixed: {
      required: _i18nInstance.t('form.error.required'),
      notType: ({ path, type, value, originalValue }) => {
        if (type === 'date') {
          return _i18nInstance.t('form.error.date')
        }

        if (type === 'number') {
          return _i18nInstance.t('form.error.number')
        }

        const castMsg =
          originalValue != null && originalValue !== value
            ? ` (cast from the value \`${originalValue}\`).`
            : '.'

        if (type !== 'mixed') {
          return (
            `${path} must be a \`${type}\` type, but the final value was: \`${value}\`` + castMsg
          )
        }

        return (
          `${path} must match the configured type. ` +
          `The validated value was: \`${value}\`` +
          castMsg
        )
      },
    },
    string: {
      email: _i18nInstance.t('form.error.email'),
    },
    array: {
      min: ({ min }) => _i18nInstance.t('form.error.array.min', { count: min }),
    },
    number: {
      min: ({ min }) => _i18nInstance.t('form.error.number.min', { min: min }),
    },
  })
}
